import React, { Component } from "react";
import { Link } from "react-router-dom";
import { generalS } from "../../strings/general";
import { host } from "../env";
import "../../styles/css/footer.css";

import goethe from "../../imgs/footer/Goethe_instut-01.jpg";
import giz from "../../imgs/footer/GIZ.jpg";
import germanCoorporate from "../../imgs/footer/German_cooperation.png";
import karga from "../../imgs/footer/Karge Logo-01.png";
import x_line from "../../imgs/footer/X-Line.jpg";
import paia from "../../imgs/footer/Paia_Agency_Logo2020.jpg"

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { language } = this.props.context;
    let { footerText } = this.props;
    
    let localLanguage = localStorage.getItem('language');
    if (localLanguage != null) {
      language = localLanguage;
    }

    return (
      <div className={"footer-main"}>
        {/* <div className={"footer-col"}>
          <div className={"footer-col-title-container"}>
            <h4 className={"footer-col-title"}>{generalS.cooperation[language]}</h4>
          </div>
          <div className={"footer-col-image-contailer-left"}>
            <img src={goethe} />
          </div>
          <div className={"footer-col-image-contailer-left"}>
            <img src={germanCoorporate} />
          </div>
        </div>
        <div className={"footer-col"}>
          <div className={"footer-col-title-container"}>
            <h4 className={"footer-col-title"}>{generalS.partners[language]}</h4>
          </div>
          <div className={"footer-col-image-contailer"}>
            <img src={karga} />
          </div>
          <div className={"footer-col-image-contailer"}>
            <img src={x_line} />
          </div>
          <div className={"footer-col-image-contailer"}>
            <img src={paia} />
          </div>
        </div>
        <div className={'footer-paragraph-container'}>
          {footerText && footerText[0] ?
            <p>{footerText[0].data.value.details[0]}</p>
            : ("")}
        </div> */}
      </div>
    );
  }
}

const styles = {};

export default Footer;
